import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import VueCountdown from "@chenfengyuan/vue-countdown";
import VueVirtualScroller from "vue-virtual-scroller";

import { createApp } from "vue";
import App from "./app.vue";
import i18n from "./common2/i18n";
import router from "./router";
import store from "./store";
//import Loading from 'vue-loading-overlay'

createApp(App)
  .use(store)
  .use(i18n)
  .use(router)
  .use(PerfectScrollbar)
  .use(VueVirtualScroller)
  .component(VueCountdown.name, VueCountdown)
  .mount("#app");
